'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { Button } from '../ui/button';
import { FaFacebook } from 'react-icons/fa';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function BlogShare({ blog }: { blog: Blog }) {
  const { t } = useTranslations();

  const handleShare = () => {
    if (typeof window === 'undefined') return;

    const baseUrl =
      (blog as any)?.canonical_url ||
      (blog as any)?.url ||
      `${window.location.origin}/blog/${blog.slug}`;

    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseUrl)}`;

    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=600');
  };

  return (
    <Button
      variant={'outline'}
      onClick={handleShare}
      className="h-[52px] w-full sm:h-14 sm:w-fit lg:h-[60px]"
    >
      <FaFacebook size={24} /> {t('text1047')}
    </Button>
  );
}
